/* global System window */

const readEnvUrlFlag = (key) => {
  const enableKey = `enable-${key}`;
  const disableKey = `disable-${key}`;
  const hasFlag = flag => !!window.location.search.match(new RegExp(`[?&]${flag}(&|$)`));
  if (hasFlag(enableKey)) {
    return true;
  } else if (hasFlag(disableKey)) {
    return false;
  }
  return undefined;
};

const getStorage = (key) => {
  try {
    return window.localStorage.getItem(key);
  } catch (e) {
    return null;
  }
};

const setStorage = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (e) {
    return;
  }
};

const getEnvFlag = (key, defaultVal = false) => {
  let envVal = readEnvUrlFlag(key);
  if (envVal !== undefined) {
    setStorage(key, envVal ? '1' : '0');
  } else {
    const storedVal = getStorage(key);
    envVal = (storedVal === null) ? defaultVal : storedVal === '1';
  }
  return envVal;
};

export const mocksEnabled = () => getEnvFlag('mocks');
export const bundlesEnabled = () => getEnvFlag('bundles', true);



// WEBPACK FOOTER //
// ./config-bb-module-loader/scripts/dev.js